<div class="modal__header">
    <div class="modal__title">
        SET USER ATTESTATION TEXT
    </div>
    <div class="modal__close" (click)="closeModal()">
        <i class="fas fa-times"></i>
    </div>
</div>
<form>
    <div class="modal__content">
        <p>Use this to create an attestation for users to confirm when they complete a spread.</p>
        <label class="input-field-label" for="attestation-text">Attestation Text</label>
        <textarea [(ngModel)]="attestationText" name="attestationText" id="attestation-text" rows="4" class="form-control"
                  placeholder="Ex: I confirm that the spreads I am completing are spread in accordance with the bank’s practices, and these financials can be used for ratings, analytics and reporting use cases.">
        </textarea>
    </div>

    <div class="modal__footer">
        <button type="reset" class="btn btn-link" (click)="closeModal()">Close</button>
        <button type="submit" class="btn btn-primary" (click)="handleSave()">Save</button>
    </div>
</form>
